<template>
    <div class="container-fluid">
        <header class="import-page-heading">
            <div>
                <h1>Import members</h1>
                <p>Add many members at once from an Excel workbook.</p>
            </div>
            <router-link to="/member" class="btn btn-outline-secondary">
                <i class="pi pi-arrow-left" aria-hidden="true"></i>
                <span>Back to directory</span>
            </router-link>
        </header>

        <MemberImport></MemberImport>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import MemberImport from "@/components/master/MemberImport.vue";

export default defineComponent({
    name: "MemberImportPage",
    components: {
        MemberImport
    }
})
</script>

<style scoped>
.import-page-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin: 0 0 1.5rem;
}

.import-page-heading h1 {
    margin: 0;
    color: #1f2937;
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -0.025em;
}

.import-page-heading p {
    margin: 0.35rem 0 0;
    color: #6b7280;
    font-size: 0.95rem;
}

.import-page-heading .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
}

@media (max-width: 575.98px) {
    .import-page-heading {
        flex-direction: column;
        margin-bottom: 1rem;
    }

    .import-page-heading h1 {
        font-size: 1.5rem;
    }
}
</style>
